import React from 'react';
import styles from './Button.module.scss';

const Button = ({ children, kind, ...props }) => (
    <button className={`${styles.button} ${styles[kind || 'primary']}`} {...props}>{children}</button>
);

export default Button;
